import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const AnimatedCard = () => {
  const [isFlipped, setIsFlipped] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  const handleFlip = () => {
    if (!isAnimating) {
      setIsFlipped(!isFlipped)
      setIsAnimating(true)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-[400px] perspective-1000">
      <AnimatePresence mode="wait">
        <motion.div
          key={isFlipped ? 'back' : 'front'}
          initial={{ rotateY: isFlipped ? -180 : 0, opacity: 0 }}
          animate={{ rotateY: isFlipped ? 0 : 0, opacity: 1 }}
          exit={{ rotateY: isFlipped ? 0 : 180, opacity: 0 }}
          transition={{ duration: 0.6, animationDirection: 'normal' }}
          onAnimationComplete={() => setIsAnimating(false)}
          onClick={handleFlip}
          className="w-64 h-96 cursor-pointer"
        >
          {isFlipped ? (
            // Back of card
            <motion.div
              className="w-full h-full bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl p-6 shadow-xl"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="text-white text-2xl font-bold mb-4"
              >
                Sprite Maker
              </motion.h2>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
                className="text-white/90"
              >
                Create beautiful sprites with our powerful tools and intuitive interface.
              </motion.p>
              <motion.div
                className="absolute bottom-6 right-6"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.7, type: "spring" }}
              >
                <svg className="w-8 h-8 text-white/70" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </motion.div>
            </motion.div>
          ) : (
            // Front of card
            <motion.div
              className="w-full h-full bg-white rounded-xl p-6 shadow-xl"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <motion.div
                className="w-16 h-16 mb-6 mx-auto"
                animate={{
                  rotate: [0, 360],
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                <div className="w-full h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg" />
              </motion.div>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-gray-800 text-2xl font-bold text-center mb-4"
              >
                Click to Flip
              </motion.h2>
              <motion.div
                className="grid grid-cols-2 gap-2"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                {[...Array(4)].map((_, i) => (
                  <motion.div
                    key={i}
                    className="h-12 bg-gray-100 rounded-lg"
                    whileHover={{ scale: 1.05, backgroundColor: "#f3f4f6" }}
                    transition={{ duration: 0.2 }}
                  />
                ))}
              </motion.div>
            </motion.div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default AnimatedCard 